import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { LanguageSelector } from '@/components/layout/LanguageSelector';
import SidebarIcon from '@/components/layout/SidebarIcon';
import { buttonVariants } from '@/components/ui/button';
import { useTranslation } from '@/hooks/useTranslation';
import { cn } from '@/lib/utils';

export type AuthPageProps = {
  children: ReactNode;
  link?: { title: string; to: string };
};

export default function AuthPage({ children, link }: AuthPageProps) {
  const { t } = useTranslation();

  return (
    <div className="container relative grid h-screen flex-col items-center justify-center lg:max-w-none lg:grid-cols-2 lg:px-0">
      <div className="absolute right-4 top-4 md:right-8 md:top-8 flex gap-4">
        {link && (
          <Link
            className={cn(buttonVariants({ variant: 'ghost' }))}
            to={link.to}
          >
            {link.title}
          </Link>
        )}
        <LanguageSelector />
      </div>
      <div className="relative hidden h-full flex-col bg-muted p-10 text-white dark:border-r lg:flex">
        <div className="absolute inset-0 bg-zinc-800" />
        <div className="relative z-20 w-full flex">
          <SidebarIcon
            className="m-auto"
            logoTheme="dark"
            showText={false}
            size="lg"
          />
        </div>
        <div className="relative z-20 mt-auto">
          <blockquote className="space-y-2">
            <p className="text-lg">{t('common:cargoMotto')}</p>
          </blockquote>
        </div>
      </div>
      <div className="absolute top-20 w-full flex items-center lg:hidden">
        <SidebarIcon className="m-auto" showText={false} size="lg" />
      </div>
      <div className="lg:p-8">{children}</div>
    </div>
  );
}
